import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import * as moment from 'moment';
import { Observable, of } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';

@Injectable({
	providedIn: 'root'
})
export class DataServiceService {
	staffData: any;

	constructor(private readonly firestore: AngularFirestore) {}

	// ----------------------------------Staff-----------------------------------------------------------

	public getStaffDetails(staffId): Observable<any> {
		if (this.staffData) {
			return of(this.staffData);
		}
		return this.firestore.collection('staffs').doc(staffId).valueChanges();
	}

	public getAllTemplate() {
		return this.firestore
			.collection('templates', (ref) => ref.where('published', '==', true))
			.snapshotChanges()
			.pipe(
				map((actions) =>
					actions.map((snapshotData) => {
						let data = {};
						data = snapshotData.payload.doc.data();
						const id = snapshotData.payload.doc.id;
						return { id, ...data };
					})
				)
			);
	}

	public getAccessControlDetails(groupIds: Array<string>) {
		return this.firestore
			.collection('access_controls', (ref) => ref.where('isActive', '==', true))
			.snapshotChanges()
			.pipe(
				map((actions) =>
					actions.map((snapshotData) => {
						let data = {};
						data = snapshotData.payload.doc.data();
						const _id = snapshotData.payload.doc.id;
						if (groupIds.includes(data['groupName'])) {
							return { _id, ...data };
						}
					})
				)
			);
	}

	public getComponentsData(docId) {
		return this.firestore.collection('component_lists').doc(docId).get();
	}

	public getSudentDocData(studentId): Observable<any> {
		return this.firestore.collection('students').doc(studentId).valueChanges();
	}

	public getStudentByWhere(studentEmailArray) {
		return this.firestore.collection('students', (ref) => ref.where('upn', 'in', studentEmailArray)).valueChanges();
	}

	public updateExistingStaff(currentUser) {
		return this.firestore.collection('staffs').doc(currentUser.email).update({
			updated_at: moment().format(),
			auth_token: currentUser.decodedAuthToken,
			lastSignInTime: moment(currentUser.metadata.lastSignInTime).format()
		});
	}

	public insertNewStudentData(staff) {
		return this.firestore.collection('staffs').doc(staff.upn).set(staff);
	}

	setStaffData(data) {
		this.staffData = data;
	}

	getAllStudentDetails(staffEmail): Observable<any> {
		return this.getStaffDetails(staffEmail).pipe(
			mergeMap((staffData) => {
				return combineLatest(staffData.students.map((studentEmail) => this.getSudentDocData(studentEmail)));
			})
		);
	}

	public getCollectionDocWithIdByWhere(collectionName, fieldName, queryOperator, searchValue) {
		return this.firestore
			.collection(collectionName, (ref) =>
				ref.where(fieldName, queryOperator, searchValue).where('published', '==', true)
			)
			.get();
	}
}
